export default __webpack_public_path__ + "static/pop_placeholder-6a8afd95e658a37291b8e851f193c31b.jpg";